module.exports = __webpack_public_path__ + "static/About-us-1920-1080@2x.ae80307a.png";